<template>
<div style="height: 100%;">
	<div class="rms-container"
	v-infinite-scroll="loadMore"
	infinite-scroll-disabled="loading"
	infinite-scroll-distance="10">
		<!-- 搜索 -->
		<div class="search">
			<el-input placeholder="交货单号/SAP凭证号" v-model="formInline.queryStr" size="small">
				<el-button slot="append" size="small" @click="query()">查询</el-button>
			</el-input>
		</div>
		<div style="height: 55px;"></div>
		
		<!-- 列表 -->
		<div class="list-container" v-if="tableList.length>0">
			<el-card class="item" v-for="(item, index) in tableList" :key="index">
				<div slot="header" class="title">
					<div class="cell">
						<span v-if="formInline.type=='1'">{{ item.budat }}</span>
						<span v-if="formInline.type=='2'">{{ item.vatDat }}</span>
					</div>
					<div class="cell">{{ item.delivery }}</div>
					<div class="cell red">{{ item.overdueDay }}天</div>
				</div>
				<div class="content">
					<div class="text row">
						<div class="cell-l">{{ item.dmbtr | formatYuan }}</div>
						<div class="cell-r">{{ item.kidno }}</div>
					</div>
				</div>
				<div class="btn">
					<el-button size="mini" @click="openDetail(item)">详情</el-button>
				</div>
			</el-card>
		</div>
		<!-- 加载更多 -->
		<div class="scroll-more" v-if="loading">加载中...</div>
		<div class="scroll-more" v-if="tableList.length > 0 && listsClose">没有更多了</div>
		<el-empty description="暂无数据" v-if="tableList.length==0 && listsClose"></el-empty>
		
		<!-- 详情弹层 -->
		<el-dialog title="订单详情" class="revise-content" center :visible.sync="infoFlag" fullscreen :modal="false">
			<v-RMSDetail :pageData="infoData" v-if="infoFlag"></v-RMSDetail>
		</el-dialog>
	</div>
	<!-- 水印 -->
	<v-Watermark v-if="watermarkContent" :content="watermarkContent"></v-Watermark>
</div>
</template>

<script>
import RMSDetail from '../../../components/RMS/detail';
import Watermark from '../../../components/RMS/watermark';
import util from "@/common/util";
export default {
name: "RMSVbelnList",
components:{
	'v-RMSDetail':RMSDetail,
	'v-Watermark':Watermark,
},
data () {
	return {
		//form
		formInline:{
			type: 1,
			vbeln: '',
			queryStr: '',
		},
		tableList:[],  //列表
		//分页
		paginationConf:{
			pageNum:0,
			pageSize:15,
			pageTotal:0
		},
		loading: false,
		listsClose: false,
		infoFlag: false,  //详情
		infoData: {},  //详情传参
		watermarkContent: null,  //水印
	};
},
filters:{
  formatYuan(val){
    let str = val ? val + '元' : '0.00元';
    return str;
  },
},
created() {
	this.watermarkContent = sessionStorage.getItem("NICKNAME") + (sessionStorage.getItem("MOBILE").toString()!='null' ? sessionStorage.getItem("MOBILE").slice(-4) : '');
	this.formInline.type = this.$route.query.type;
	this.formInline.vbeln = this.$route.query.vbeln;
	document.title = this.$route.query.vbeln;
	this.baseQueryButton();
},
methods: {
	// 初始化
	async init(){
		let res = await this.$api.receivableQyweixinDetails({...this.formInline, ...this.paginationConf});
		if(res.code===200 && res.result){
			this.tableList = this.tableList.concat(res.result.list);
			this.paginationConf.pageTotal = res.result.totalCount;
			if (res.result.page >= res.result.totalPage) {
				this.listsClose = true;
			}
		}else{
			this.listsClose = true;
		};
	},
	// 查询
	query(){
		this.tableList = [];
		this.paginationConf.pageNum = 0;
		this.loading = false;
		this.listsClose = false;
		this.loadMore();
	},
	// 加载列表数据/滑到底部自动加载
	loadMore() {
		if (this.listsClose) {
			return false;
		};
		this.loading = true;
		setTimeout(async () => {
			this.paginationConf.pageNum += 1;
			await this.init();
			this.loading = false;
		}, 200);
	},

	// 查看详情
	async openDetail(obj){
		this.infoData = obj;
		this.infoData.clientType = 'mobile';
		this.infoFlag = true;
	},
}
};
</script>
<style lang="less" scoped>
.rms-container {
	height: 100%;
	overflow-y: auto;
	position: relative;
	z-index: 2;
	.search {
		padding: 10px 15px;
		background-color: #fff;
		border-bottom: 1px solid #ececec;
		box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
	}
	.list-container {
		margin: 0 10px;
		.item {
			margin-top: 10px;
			font-size: 12px;
			/deep/.el-card__header {
				padding: 0;
			}
			/deep/.el-card__body {
				padding: 0;
			}
			.title {
				height: 40px;
				line-height: 40px;
				padding: 0 5px;
				font-weight: bold;
				display: flex;
				justify-content: space-between;
				.cell {
					padding: 0 5px;
				}
				.red {
					color: #D9001B;
				}
			}
			.content {
				padding: 10px;
				.row {
					display: flex;
				}
				.text {
					line-height: 16px;
					padding: 3px 0;
					.small {
						color: #999;
					}
				}
				.cell-l {
					min-width: 90px;
				}
			}
			.btn {
				border-top: 1px solid #EBEEF5;
				padding: 5px 10px;
				text-align: right;
			}
		}
	}
}
.scroll-more {
	padding: 15px 0;
	text-align: center;
	font-size: 14px;
	color: #5e6d82;
}
</style>
